import React, { useState, useEffect } from 'react';
import './ButtonSpinner.css'; // Import the CSS file

const ButtonSpinner = ({ label = 'Not set', isLoading: parentLoadingState = false, onClick}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(parentLoadingState);

  useEffect(() => {
    // If the parent controls the loading state, update the component's state accordingly
    setIsLoading(parentLoadingState);
    setIsDisabled(parentLoadingState);
  }, [parentLoadingState]);

  const handleClick = (e) => {
    // Call the parent's onClick handler (if it exists)
    if (onClick) {
        onClick(e); // Pass the event to the parent's onClick handler
      }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button 
        onClick={handleClick}
        disabled={isDisabled} 
        style={{ position: 'relative' }}
      >
        {label}
      </button>
      {isLoading && (
        <div 
          style={{
            position: 'absolute',
            top: '25%',
            bottom: '25%',
            right: '49%',
            left: '49%',
            transform: 'translate(-50%, -50%)',
            border: '4px solid transparent',
            borderTop: '4px solid #000',
            borderRadius: '50%',
            width: '20px',
            height: '20px',
            animation: 'spin 1s linear infinite'
          }}
        />
      )}
    </div>
  );
};

export default ButtonSpinner;
